// extracted by mini-css-extract-plugin
module.exports = {"howtoStart":"HowToStartTabs_howtoStart___IyNr"};